// extracted by mini-css-extract-plugin
module.exports = {"page-content":"dashboard-page-content_page-content__1sY_c"};